export default {
  Feature: {
    WelcomeTitle: 'Chào mừng thầy cô đến với EMIS Ôn tập',
    WelcomeDescription: 'Trợ thủ học tập trực tuyến đắc lực cho Giáo viên và Học sinh',
    WelcomeExplore: 'Hỗ trợ linh hoạt với<br> những tính năng hấp dẫn',
    ComposeAssign: 'Soạn và giao bài tập ',
    ComposeAssignDescription: 'Dễ dàng, linh hoạt,<br> đa dạng các loại bài tập',
    AbundantCourse: 'Kho học liệu phong phú',
    AbundantCourseDescription: 'Chuẩn bị phiếu bài tập<br> dễ dàng với kho học liệu ',
    TeacherCommunity: 'Cộng đồng Giáo viên SISAP Ôn tập ',
    TeacherCommunityDescription: 'Học liệu miễn phí',
    ViewHelp: 'Xem hướng dẫn',
    Join: 'Tham gia ngay',
    ExploreFeature: 'Khám phá tính năng',
    StartUsing: 'Bắt đầu sử dụng',
    ShareWonder: 'Thầy cô chia sẻ thắc mắc đến<div class="text-accent-200">Cộng đồng giáo viên SISAP Ôn tập</div>để nhận được hỗ trợ nhé!',
    LinkFaceBookGroup: 'https://www.facebook.com/groups/lms.sisap.misa/',
    FirstTimeCompose: 'Lần đầu người dùng soạn bài'
  }
}
